// extracted by mini-css-extract-plugin
export default {"tooltip__box":"Tooltip_tooltip__box__nDFFZ","active":"Tooltip_active__sbDcw","tooltip__arrow":"Tooltip_tooltip__arrow__ra+U0"};